<div class="barlinedef">
    <div class="compfill" [style.width]="this.percentageTotal"></div>
</div>   